// Summary Modal for displaying AI-generated note summaries
import { useState, useEffect } from 'react';
import './SummaryModal.css';

export default function SummaryModal({ isOpen, onClose, summary, isLoading, error }) {
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (copied) {
            const timer = setTimeout(() => setCopied(false), 2000);
            return () => clearTimeout(timer);
        }
    }, [copied]);

    const handleCopy = async () => {
        if (summary) {
            try {
                await navigator.clipboard.writeText(summary);
                setCopied(true);
            } catch (err) {
                console.error('Failed to copy:', err);
            }
        }
    };

    if (!isOpen) return null;

    return (
        <div className="summary-modal-overlay" onClick={onClose}>
            <div className="summary-modal" onClick={e => e.stopPropagation()}>
                <div className="summary-modal-header">
                    <h3>✨ AI Summary</h3>
                    <button className="summary-modal-close" onClick={onClose}>×</button>
                </div>

                <div className="summary-modal-content">
                    {isLoading && (
                        <div className="summary-loading">
                            <div className="summary-loading-spinner"></div>
                            <span>Generating summary...</span>
                        </div>
                    )}

                    {error && (
                        <div className="summary-error">
                            <span className="summary-error-icon">⚠️</span>
                            <span>{error}</span>
                        </div>
                    )}

                    {!isLoading && !error && summary && (
                        <div className="summary-text">
                            {summary.split('\n').map((line, idx) => (
                                <p key={idx}>{line}</p>
                            ))}
                        </div>
                    )}
                </div>

                {!isLoading && summary && (
                    <div className="summary-modal-footer">
                        <button
                            className="summary-copy-btn"
                            onClick={handleCopy}
                        >
                            {copied ? '✓ Copied!' : '📋 Copy Summary'}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}
